import { observer } from 'mobx-react';
import { useEffect } from 'react';
import SignLayout from '../../../components/layouts/SignLayout';
import MfaSetupForm from './components/MfaSetupForm';
import useHistory from '../../../hooks/useHistory';
import { paths } from '../../../utils/constants/routes';
import './components/MfaSetupForm.less';

/**
 * TD-1976 Phase 4 — MFA setup page.
 *
 * Reached only via the post-login guard (`useAppRouteGuard`) for users whose
 * ID token still carries `custom:mfa_setup_required="true"`. Renders the
 * reusable <MfaSetupForm /> in `enforced` mode (amber blocker banner, no
 * cancel). Once the user verifies a 6-digit code, AuthStore.verifyMfaSetup
 * force-refreshes the Cognito session — the new ID token drops the claim and
 * the guard releases on the next pass. We navigate to HOME_FULL to land the
 * user on the post-login dashboard.
 */
const MfaSetup = observer(() => {
  const { navigate } = useHistory();

  useEffect(() => {
    document.title = `transact.digital GmbH - MFA Setup`;
  }, []);

  return (
    <SignLayout>
      <div className="mfa-setup-wrapper">
        <MfaSetupForm enforced onComplete={() => navigate(paths.HOME_FULL)} />
      </div>
    </SignLayout>
  );
});

export default MfaSetup;
